import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import '../../styles/dashboard.scss';
import PropTypes from 'prop-types';
import { OrderBox, notFoundIcon } from '../../assets/added_icons/index';

function OrderListPhysical({ aRow }) {
  const [showAllOrders, setShowAllOrders] = useState(false);
  const itemsToShow = showAllOrders ? aRow?.orders : aRow?.orders?.slice(0, 2);
  return (
    <>
      <div style={{ overflow: 'unset', marginTop: '5px', padding: '0px 20px' }}>
        <Typography gutterBottom className="subTitles">
          Attached orders
        </Typography>
      </div>
      {itemsToShow?.length ? (
        <>
          <div className="orders" style={{ padding: '0px 10px' }}>
            {itemsToShow?.map((item, index) => (
              <div key={index} className="TBrow" id={item.id} role="button" tabIndex={0}>
                <Box sx={{ display: 'flex', gap: '60px', alignItems: 'center' }} id={item.id}>
                  <img src={OrderBox} width="40px" height="40px" alt="" id={item.id} />
                  <div className="aligh_row_items" id={item.id}>
                    <div
                      className="bold_heading"
                      id={item.id}
                      style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '200px' }}
                    >
                      {item.tracking}
                    </div>
                    <div className="light_text" id={item.id}>
                      {item.room_number}
                    </div>
                  </div>
                  <div className="aligh_row_items" id={item.id}>
                    <div
                      className="bold_heading"
                      id={item.id}
                      style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '200px' }}
                    >
                      Receiver
                    </div>
                    <div className="light_text" id={item.id}>
                      {item?.receiver?.first_name} {item?.receiver?.last_name}
                    </div>
                  </div>
                </Box>
              </div>
            ))}
          </div>
          {aRow?.orders.length >= 3 ? (
            <Button
              variant="outlined"
              sx={{ width: '97%', margin: '0px 10px' }}
              onClick={() => setShowAllOrders(!showAllOrders)}
            >
              {showAllOrders ? 'Show Less' : 'Show All'}
            </Button>
          ) : (
            ''
          )}
        </>
      ) : (
        <img src={notFoundIcon} alt="" width="15%" style={{ margin: '0px 20px' }} />
      )}
    </>
  );
}

OrderListPhysical.propTypes = {
  aRow: PropTypes.object,
};
export default OrderListPhysical;
